import {TermsStatuses} from 'new-constants/common.constants';
import {PHONE_POPUP} from 'new-components/popups/phone/Phone';
import {NAME_POPUP} from 'new-components/popups/name/Name';
import {EMAIL_POPUP} from 'new-components/popups/email/Email';
import {BIRTHDAY_POPUP} from 'new-components/popups/birthday/Birthday';
import {TERMS_POPUP} from 'new-components/popups/terms/Terms';
import {GUEST_ORDER_POPUP} from "new-constants/popup.constants";

/*function get(customer, restaurant, openedMainCategory) {
    const currentRestaurant = restaurant.currentRestaurant;
    if (!currentRestaurant) {
        return null;
    }

    if (currentRestaurant.isPhoneRequired && !customer.phone) {
        return Routes.PhonePage;
    }

    if (currentRestaurant.isNameRequired && !customer.nickname) {
        return Routes.NamePage;
    }

    if (currentRestaurant.isEmailRequired && !customer.email) {
        return Routes.EmailPage;
    }

    const isMainCategoryRequiresBirthdate = openedMainCategory && openedMainCategory.type === MainCategoryTypes.member;

    if ((currentRestaurant.isBirthdateRequired || isMainCategoryRequiresBirthdate) && !customer.birthdate) {
        return Routes.BirthdatePage;
    }

    if (
        !customer.terms ||
        (customer.terms &&
            customer.restaurant &&
            customer.terms.status !== TermsStatuses.ACCEPTED &&
            customer.restaurant.restaurantId === currentRestaurant.restaurantId)
    ) {
        return Routes.AcceptTermsPage;
    }
}*/

export const getRegistrationPopup = (currentCustomer, currentRestaurant) => {
	if (!currentRestaurant) {
		return null;
	}

	return null;

	if (currentRestaurant.isPhoneRequired && !currentCustomer.phone) {
		return PHONE_POPUP;
	}

	if (currentRestaurant.isNameRequired && !currentCustomer.nickname) {
		return NAME_POPUP;
	}

	if (currentRestaurant.isEmailRequired && !currentCustomer.email) {
		return EMAIL_POPUP;
	}

	if (currentRestaurant.isBirthdateRequired && !currentCustomer.birthdate) {
		return BIRTHDAY_POPUP;
	}

	if (
		!currentCustomer.terms ||
		(currentCustomer.terms &&
			currentCustomer.restaurant &&
			currentCustomer.terms.status !== TermsStatuses.ACCEPTED &&
			currentCustomer.restaurant.restaurantId === currentRestaurant.restaurantId)
	) {
		return TERMS_POPUP;
	}
};
